import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";

import Modal from "components/Modal";
import Button from "components/Button";

import { mq } from "utils";
import css from "styles";
import { sizes, colors, strings } from "assets/constants";

export default function EditModal(props: {
  visible: boolean;
  hideToast?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  renderForm?: () => JSX.Element;
  renderContent?: () => JSX.Element;
  closeByTouchOut?: boolean;
}) {
  const { visible, hideToast, onCancel, onConfirm, renderForm, renderContent } =
    props;

  return (
    <Modal visible={visible} close={onCancel} hideToast={hideToast}>
      <>
        {renderContent ? (
          renderContent()
        ) : (
          <ScrollView keyboardShouldPersistTaps="handled">
            {renderForm && renderForm()}

            <View
              style={{
                ...css.paddingH,
                ...css.rowCenterAlign,
                marginBottom: sizes.space,
              }}
            >
              <Button
                onPress={onConfirm}
                title={{ value: strings.confirm }}
                width={mq(100)}
                bgColor={colors.success}
                style={{ marginRight: sizes.space }}
              />

              <Button
                onPress={onCancel}
                title={{ value: strings.cancel }}
                outline
                width={mq(100)}
                bgColor={colors.danger}
              />
            </View>
          </ScrollView>
        )}
      </>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modal: {
    margin: mq(0),
    marginTop: mq(40),
    justifyContent: "flex-end",
  },
  container: {
    backgroundColor: colors.screensBg,
    borderTopLeftRadius: sizes.radius.lg,
    borderTopRightRadius: sizes.radius.lg,
  },
  list: { ...css.paddingH },

  topSection: { flex: 1 },
});
